import { render, staticRenderFns } from "./emailForm.vue?vue&type=template&id=d803a826&scoped=true&"
import script from "./emailForm.vue?vue&type=script&lang=js&"
export * from "./emailForm.vue?vue&type=script&lang=js&"
import style0 from "./emailForm.vue?vue&type=style&index=0&id=d803a826&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d803a826",
  null
  
)

export default component.exports